import { atomWithReset } from 'jotai/utils';

import { CancelUnavailableSendMessagePane } from './types';

export const cancelUnavailableSendMessagePane = atomWithReset<CancelUnavailableSendMessagePane>({
  isOpen: false,
});
